module.exports = "/images/logo-large@2x.png?c2ad8adb3a8bf08742edbdbef3b60e41";